import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

import Loader from "components/Common/Loader";
import NoResults from "./NoResults";

const Wrapper = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const TableOverlay = ({ results }) => {
  if (!results) {
    return (
      <Wrapper>
        <Loader margin="1em" />
      </Wrapper>
    );
  }

  if (results.length === 0) {
    return (
      <Wrapper>
        <NoResults type="application" />
      </Wrapper>
    );
  }

  return null;
};

TableOverlay.propTypes = {
  results: PropTypes.array
};

export default TableOverlay;
